export default __webpack_public_path__ + "static/media/jul6.9d5ace98.jpg";